import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RatingService } from 'src/app/services/rating/rating.service';
import { RateSubmitResponse } from 'src/app/services/rating/rating.type';

@Component({
  selector: 'app-submit-rating',
  templateUrl: './submit-rating.component.html',
  styleUrls: ['./submit-rating.component.scss']
})
export class SubmitRatingComponent implements OnInit {

  @Input() productId: string;
  @Input() orderId: number;
  @Output() close = new EventEmitter<boolean>();
  isReviewFormActive = true;
  reviewForm : FormGroup;
  rating: number = 0;
  ratingId: number = 0;

  constructor(private ratingService: RatingService, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.reviewForm = this.fb.group({
      title: new FormControl("", [Validators.required]),
      desc: new FormControl("")
    });
  }

  public toggleReviewform() {
    // this.isReviewFormActive = !this.isReviewFormActive;
    this.close.emit(true);
  }

  public submitReview() {
    this.submitRatingAndReview(Number(this.productId), this.orderId, this.rating, true, this.reviewForm.get('title').value, this.reviewForm.get('desc').value);
  }

  public starClicked(starNumber: number) {
   this.rating = starNumber;
  //  this.submitRatingAndReview(Number(this.productId), this.rating, false);
  }

  private submitRatingAndReview(productId: number, orderId: number, rating: number, hideActionSheet: boolean, title?: string, desc?: string) {
    this.ratingService.submitRatingWithReview(productId, orderId, rating, title, desc).subscribe((res: RateSubmitResponse) => {
      if(res && res.Result === 'Success' && res.ResponseData) {
        this.ratingId = res.ResponseData;
        if(hideActionSheet) {
          this.close.emit(true);
        }
      }
    });
  }
}
